import React from 'react';
import { DataTableRenderCellParams, InputTable } from '@/components/custom/erp';
import InputTableActionBar from './InputTableActionBar';
import { getInvoiceCollectionColumns } from './cols';

import { SelectedCellInfo } from '@/features/danh-muc/hop-dong-khe-uoc/khe-uoc/hooks/useThongTinLaiSuat';
import { ChiTietKheUocThanhToan } from '@/types/schemas';

interface ChiTietThanhToanTabProps {
  mode: 'add' | 'edit' | 'view';
  rows: ChiTietKheUocThanhToan[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: (params: { id: string; row: ChiTietKheUocThanhToan }) => void;
  onCellClick?: (params: DataTableRenderCellParams<ChiTietKheUocThanhToan>) => void;
  onAddRow: () => void;
  onDeleteRow: () => void;
  onCopyRow: () => void;
  onPasteRow: () => void;
  onMoveRow: (direction: 'up' | 'down') => void;
  onCellValueChange: (
    rowUuid: string,
    field: keyof ChiTietKheUocThanhToan,
    newValue: ChiTietKheUocThanhToan[keyof ChiTietKheUocThanhToan]
  ) => void;
}

const ChiTietThanhToanTab: React.FC<ChiTietThanhToanTabProps> = ({
  mode,
  rows,
  selectedRowUuid,
  onRowClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onPasteRow,
  onMoveRow,
  onCellValueChange
}) => {
  return (
    <InputTable
      rows={rows}
      onRowClick={onRowClick}
      className='h-96'
      selectedRowId={selectedRowUuid || undefined}
      columns={getInvoiceCollectionColumns(onCellValueChange)}
      getRowId={row => row?.uuid || ''}
      actionButtons={
        <InputTableActionBar
          mode={mode}
          handleAddRow={onAddRow}
          handleDeleteRow={onDeleteRow}
          handleCopyRow={onCopyRow}
          handlePasteRow={onPasteRow}
          handleMoveRow={onMoveRow}
        />
      }
    />
  );
};

export default ChiTietThanhToanTab;
